import React from 'react'
import FormSubmitButton from './FormSubmitButton'

const Form = ({name, action, children }) => {
    return (
            
                        <form className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8" name={name} action={action} method="POST" netlify-honeypot="bot-field" data-netlify="true">
                            {children}
                            <FormSubmitButton form={name}/>
                        </form>
                    
    )
}

export default Form